import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button.component';
import { ButtonsGroupComponent } from './buttons-group/buttons-group.component';

@NgModule({
    declarations: [ButtonComponent, ButtonsGroupComponent],
    imports: [CommonModule],
    exports: [ButtonComponent, ButtonsGroupComponent],
})
export class ButtonModule {}
